<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Paso de página</span>
  <div class="section flex flex-row gap-2.5">
    <ng-lottie *ngIf="longLottieOptions" [options]="longLottieOptions" width="55px" height="55px"></ng-lottie>
    <div class="flex flex-col gap-1.5">
      <span class="section_title">Por el lado largo</span>
      <span *ngIf="pageOrientation === 'vertical'" class="section_info"
        >Pasas las hojas hacia la izquierda, como se muestra en la animación.</span
      >
      <span *ngIf="pageOrientation === 'horizontal'" class="section_info"
        >Pasas las hojas hacia arriba, como se muestra en la animación.</span
      >
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <ng-lottie *ngIf="shortLottieOptions" [options]="shortLottieOptions" width="55px" height="55px"></ng-lottie>
    <div class="flex flex-col gap-1.5">
      <span class="section_title">Por el lado corto</span>
      <span *ngIf="pageOrientation === 'vertical'" class="section_info"
        >Pasas las hojas hacia arriba, como se muestra en la animación.</span
      >
      <span *ngIf="pageOrientation === 'horizontal'" class="section_info"
        >Pasas las hojas hacia la izquierda, como se muestra en la animación.</span
      >
    </div>
  </div>
</div>
